module.exports = __webpack_public_path__ + "img/Weapon_23.80b96ece.png";